<template lang="pug">
  v-dialog(
    v-model="show"
  )
    template(v-slot:activator="{ on }")
      v-btn(
        text
        large
        v-on="on"
        max-width="500"
      )
        v-icon.mr-4(
          color="secondary"
          left
          large
        ) mdi-file-image-outline
        | {{ title }}
    v-card
      v-img(:src="url")
        v-card-title
          v-spacer
          v-btn(@click="show = false" fab x-small)
            v-icon mdi-close

</template>

<script>
export default {
  name: 'ImageDialog',
  props: {
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
